import React from "react";
import { premium } from "./data/premium";
// import VehicleCard from "./VehicleCard";
import VehicleFullCard from "./VehicleFullCard";

export default function Premium() {
  return (


<>


<section
        className="breadcrumb-section"
        style={{ backgroundImage: "url(/images/background/inner-banner-bg.jpg)" }}
      >
        <div className="container">
          <div className="banner-content">
            <h1>Premium Cars
 </h1>
          </div>
        </div>
      </section>
  <div className="vehicle-page">
    <div className="vehicle-container">
      {premium.map((v) => (
        <VehicleFullCard key={v.id} v={v} />
      ))}
    </div>
  </div>
  
{/* 
    <section className="vehicle-page">
      <div className="container">

        <div className="vehicle-grid">
          {premium.map((vehicle) => (
            <VehicleCard key={vehicle.id} v={vehicle} />
          ))}
        </div>
      </div>
    </section> */}
</>
  );
}
